import { Box } from "@mui/material";


window.addEventListener('scroll', (event) => {
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    Array.from(document.getElementsByClassName("parallax")).forEach((el) => {
        el.style.backgroundPositionY = scrollTop / 2 + 'px'
    })
})

export function ParallaxBox(props) {
    const { sx, image, ...rest } = props;

    return <Box
        className="parallax"
        sx={{
            backgroundImage: 'url(/static/' + image + ')',
            backgroundPosition: 'center top',
            ...sx,
        }}
        {...rest} />
}